export interface Position {
  x: number
  y: number
}

export interface Size {
  width: number
  height: number
}

export interface WorkspaceItem {
  id: string
  position: Position
  size: Size
  rotation: number
  zIndex: number
}

export interface ImageItem extends WorkspaceItem {
  src: string
  originalWidth: number
  originalHeight: number
  fileName: string
  fileSize: number
  opacity: number
  flipX: boolean
  flipY: boolean
}

export interface PageConfig {
  id: string
  width: number
  height: number
  items: ImageItem[]
}

export type PageSize = "A4" | "Letter" | "Legal" | "A3" | "A5" | "Custom"
export type Orientation = "portrait" | "landscape"
export type FitMode = "fit" | "fill" | "stretch" | "actual"

export const PAGE_DIMENSIONS: Record<PageSize, { width: number; height: number }> = {
  A4: { width: 595, height: 842 },
  Letter: { width: 612, height: 792 },
  Legal: { width: 612, height: 1008 },
  A3: { width: 842, height: 1191 },
  A5: { width: 420, height: 595 },
  Custom: { width: 595, height: 842 },
}

export const DPI = 72
export const MM_TO_POINTS = 2.83465
